import React from "react";
import { NavLink } from "react-router-dom";
import { cn } from "@/lib/utils";
import { NAV, canAccess } from "@/lib/nav";
import { useAuth } from "@/context/AuthContext";
import { useApp } from "@/context/AppContext";
import { ChevronLeft } from "lucide-react";
import BrandLogo from "@/components/common/BrandLogo";

export const Sidebar = ({ collapsed, setCollapsed }) => {
  const { user } = useAuth();
  const { restaurant } = useApp();
  const items = NAV.filter((n) => canAccess(user, n.module));

  return (
    <aside
      className={cn(
        "hidden md:flex flex-col bg-sidebar text-stone-300 transition-all duration-300 shrink-0 h-dvh sticky top-0",
        collapsed ? "w-[76px]" : "w-64",
      )}
      data-testid="sidebar"
    >
      <div
        className={cn(
          "flex items-center h-16 px-5 border-b border-white/5",
          collapsed && "justify-center px-0",
        )}
      >
        {!collapsed && (
          <div className="flex items-center gap-3">
            <img
              src="/assets/logo-white.png"
              alt="StayServe"
              className="h-10 w-auto object-contain"
            />

            <div>
              <div className="font-display text-[20px] font-black tracking-tight leading-none">
                <span className="text-[#fff]">Stay</span>
                <span className="text-[#FF6B00]">Serve</span>
              </div>

              <div className="mt-1 text-[7px] font-bold uppercase tracking-[.20em] text-[#fff]">
                Hospitality operations
              </div>
            </div>
          </div>
        )}
        {collapsed && (
          <img
            src="/assets/logo-white.png"
            alt="StayServe"
            className="h-8 w-auto object-contain"
          />
        )}
      </div>

      <nav className="flex-1 overflow-y-auto no-scrollbar py-4 px-3 space-y-1">
        {items.map((n) => (
          <NavLink
            key={n.key}
            to={n.to}
            end={n.to === "/app" || n.to === "/app/admin"}
            data-testid={`nav-${n.key}`}
            className={({ isActive }) =>
              cn(
                "group flex items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-medium transition-colors relative",
                collapsed && "justify-center px-0",
                isActive
                  ? "bg-primary text-white shadow-[0_4px_12px_rgba(234,88,12,0.35)]"
                  : "text-stone-400 hover:text-white hover:bg-white/5",
              )
            }
            title={collapsed ? n.label : undefined}
          >
            <n.icon size={19} className="shrink-0" />
            {!collapsed && <span className="truncate">{n.label}</span>}
          </NavLink>
        ))}
      </nav>

      <button
        onClick={() => setCollapsed(!collapsed)}
        data-testid="sidebar-toggle"
        className={cn(
          "flex items-center gap-2 m-3 rounded-xl px-3 py-2.5 text-sm text-stone-400 hover:text-white hover:bg-white/5 transition-colors",
          collapsed && "justify-center px-0",
        )}
      >
        <ChevronLeft
          size={18}
          className={cn("transition-transform", collapsed && "rotate-180")}
        />
        {!collapsed && "Collapse"}
      </button>
    </aside>
  );
};
